import singleSpaHtml from 'single-spa-html'

const errorPages = {
  genericTotal: import('./genericTotal.js'),
  contextLoading: import('./contextLoading.js')
}

export async function createErrorPage (type = 'genericTotal', domElementGetter = undefined, pageProps = {}) {
  const initErrorPage = await errorPages[type].then(module => module.default)
  const errorPage = initErrorPage(pageProps)
  return singleSpaHtml({
    template: errorPage.template,
    domElementGetter
  })
}
